import { useMutation } from 'react-query';

import {
  BookAppointmentResponse,
  OldBookAppointmentResponse,
  ScheduleDemoResponse,
  LandingResponse,
  Pet,
} from '@/features/availability/types';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { showNotification } from '@/utils/notificationUtils';
import moment from 'moment';
import Utils from '@/utils/util';

export type BookAppointmentDTO = {
  data: {
    name?: string;
    summary?: string;
    description?: string;
    email: string;
    altEmails: string[];
    phone: string;
    serviceId: number;
    businessUserId?: number;
    startTime?: Date;
    endTime?: Date;
    startDate?: Date|string;
    endDate?: Date|string;
    tz: string;
    businessId: number | undefined | string;
    paymentIntentId?: string;
    paymentMethodId?: string;
    petId?: number;
    petDetails?: any[];
    verificationToken?: string;
    addonSids: number[] | undefined;
    duration: number | undefined;
    petCount: number;
  };
  isReschedule?: boolean;
  token?: string;
  serviceType?: string;
};

export type ScheduleDemoDTO = {
  data: {
    name?: string;
    summary?: string;
    description?: string;
    email: string;
    phone: string;
    storeName: string;
    address: string;
    zipCode: string;
    businessUserId?: string;
    promoCode?: string;
  };
  headers: {
    'loc-id'?: string;
  };
};

export type ScheduleDemoSlotDTO = {
  data: {
    id?: string;
    startTime: string;
    duration: number;
  };
  headers: {
    'loc-id'?: string;
    tz?: string;
  };
};

export const bookAppointment = ({
  data,
  serviceType,
}: BookAppointmentDTO): Promise<BookAppointmentResponse> => {
  return axios.post(
    serviceType === Utils.SERVICE_TYPES.GROOMING
      ? `/business/${data.businessId}/calendar/appointment`
      : serviceType === Utils.SERVICE_TYPES.DAY_CARE
      ? `/parent/daycare/book`
      : `/parent/boarding/book`,
    data
  );
};

export const bookWithoutRegisterAppointment = ({
  data,
  isReschedule,
  token,
  serviceType,
}: BookAppointmentDTO): Promise<BookAppointmentResponse> => {
  const url = isReschedule
    ? `/demo/appointment/add`
    : serviceType === Utils.SERVICE_TYPES.GROOMING
    ? `/business/${data.businessId}/calendar/noregistrationappointment`
    : serviceType === Utils.SERVICE_TYPES.DAY_CARE
    ? `/parent/daycare/book`
    : `/parent/boarding/book`;
  return axios.post(url, data);
};
export const scheduleDemo = ({ data, headers }: ScheduleDemoDTO): Promise<ScheduleDemoResponse> => {
  const url = `/demo/appointment/add`;
  return axios.post(url, data, {
    headers: {
      'loc-id': headers?.['loc-id'],
      tz: moment.tz.guess(true),
    },
  });
};

export const updateScheduleDemo = ({
  data,
  headers,
}: ScheduleDemoSlotDTO): Promise<ScheduleDemoResponse> => {
  const url = `demo/appointment/schedule/${data.id}`;
  return axios.post(
    url,
    { startTime: data.startTime, duration: data.duration },
    {
      headers: {
        'loc-id': headers?.['loc-id'],
        tz: moment.tz.guess(true),
      },
    }
  );
};

export const landingDetails = ({ data }: ScheduleDemoDTO): Promise<LandingResponse> => {
  const url = `/landing-leads/add`;
  return axios.post(url, data, {
    headers: {
      //'loc-id': headers?.['loc-id'],
      tz: moment.tz.guess(true),
    },
  });
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof bookAppointment>;
};

export const useBookAppointMent = ({ config }: UseUpdateBusinessOptions = {}) => {
  return useMutation({
    onSuccess: () => {},
    ...config,
    mutationFn: bookAppointment,
  });
};

type UseUpdateBusinessOptionss = {
  config?: MutationConfig<typeof bookWithoutRegisterAppointment>;
};
type UseScheduleDemoOptions = {
  config?: MutationConfig<typeof scheduleDemo>;
};

type UseScheduleDemoSlotOptions = {
  config?: MutationConfig<typeof updateScheduleDemo>;
};

type UseLandingOptions = {
  config?: MutationConfig<typeof landingDetails>;
};

export const useBookAppointMents = ({ config }: UseUpdateBusinessOptionss = {}) => {
  return useMutation({
    onSuccess: () => {},
    ...config,
    mutationFn: bookWithoutRegisterAppointment,
  });
};

export const useScheduleDemo = ({ config }: UseScheduleDemoOptions = {}) => {
  return useMutation({
    onSuccess: () => {},
    ...config,
    mutationFn: scheduleDemo,
  });
};

export const useScheduleDemoSlot = ({ config }: UseScheduleDemoSlotOptions = {}) => {
  return useMutation({
    onSuccess: () => {},
    ...config,
    mutationFn: updateScheduleDemo,
  });
};

export const useLandingDetails = ({ config }: UseLandingOptions = {}) => {
  return useMutation({
    onSuccess: () => {},
    ...config,
    mutationFn: landingDetails,
  });
};
